import AlphaIntro from './alpha/AlphaIntro';
import avatar_new from '../images/avatar_new.jpg';

const Home = () => {
  return (
    <div className='container'>
      <div className='row my-4 about'>
        {/* before SMALL it's 5 columns, starting with SMALL it's 3 columns */}
        <div className='col-5 col-sm-3 d-flex justify-content-center align-items-center avatar-div'>
          <img src={avatar_new} className='text-center avatar' alt='avatar_new'/>
        </div>
        {/* before SMALL it's 12 columns, starting with SMALL it's 9 columns */}
        <div className='col-12 col-sm-9'>
          <h2 className="heading">Привет!</h2>
          <h3 className="subheading">Меня зовут Елена, и я опытный, дипломированный в России и сертифицированный в США English Teacher</h3>
          <h4 className="subsubheading">У меня за спиной:</h4>
          <div className='mx-2'>
            <li><b>5 лет учёбы в ВУЗе</b> на учителя английского и немецкого языков (окончила с отличием)</li>
            <li><b>4 года преподавания English в ВУЗе</b> (и повышение до старшего преподавателя)</li>
            <li><b>17 лет репетиторства</b></li>
            <li><b>700+ учеников со всего мира</b></li>
            <li><b>9 лет жизни в США</b> и ежедневного общения с носителями языка (замужем за американцем)</li>
            <li><b>Сертификат TESOL</b> от Arizona State University (Teaching English to Speakers of Other Languages позволяет обучать людей, для которых английский - неродной язык)</li>
            <li>В настоящее время я <b>работаю разработчиком в США</b> (Software Engineer) и <b>продолжаю преподавать английский</b> в свободное от основной работы время</li>
            <li>У меня есть классный канал в Telegram <a href='https://www.t.me/english_witch_elena'><b>@english_witch_elena</b></a></li>
            <li>В Instagram я веду блог <a href='https://www.instagram.com/english.witch.elena'><b>@english.witch.elena</b></a></li>
          </div>
        </div>
      </div>
      <div className='row mb-4 mx-1'>
        <h4 className="subsubheading">Хоть я и волшебница английского языка, чудес не обещаю, но гарантирую, что под моим руководством вы:</h4>
        <li>разложите ГРАММАТИКУ по полочкам, чтобы говорить и писать на английском правильно</li>
        <li>расширите СЛОВАРНЫЙ ЗАПАС, чтобы общаться свободнее и без напряга</li>
        <li>узнаете много актуального СЛЕНГА и УСТОЙЧИВЫХ ФРАЗ, чтобы без проблем понимать носителей</li>
        <li>улучшите навыки ВОСПРИЯТИЯ НА СЛУХ, чтобы всегда понимать, что вам говорят другие</li>
        <li>поправите ПРОИЗНОШЕНИЕ, чтобы говорить на английском красиво и понятно</li>
        <li>а также будете ГОВОРИТЬ, ЧИТАТЬ и ПИСАТЬ (in English, конечно же!)</li>
      </div>
      <div className="m-3 p-3">
        <AlphaIntro />
      </div>
    </div>
  )
}

export default Home;